import React from 'react';
import { Example, SourceCode } from 'examples';

const ApplicationExample = ({ ...props }) =>
  <Example {...props} className="no-props">
    <p>
      This demo application uses the <code>Application</code> component.
    </p>
    <SourceCode>
      {
        '<div id="application" class="core-application">\n' +
        '  ... your application content goes here ...\n' +
        '</div>'
      }
    </SourceCode>
  </Example>;

ApplicationExample.tags = 'dialog';

export default ApplicationExample;
